import ChartV5 from "../../pages/grafico-doble/ChartV5"
import LineChart from "../highChart/dobleje/DualAxes"

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
             <ChartV5/>
          </div>
        </div>
      </div>
    </div>
  )
}
